import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { AuthenticationGuard } from "./core/auth/authentication.guard";
import { OfflineGuard } from "./shared/component/offline-guard/offline.guard";
import { VisitorUpdateFormComponent } from "./login/visitor-update-form/visitor-update-form.component";

const routes: Routes = [
  { path: "candidate-entry/:str", loadChildren: () => import(`./candidate-entry/candidate-entry.module`).then((m) => m.CandidateEntryModule), canActivate: [OfflineGuard] },
  { path: "visitor-entry", loadChildren: () => import(`./visitor-req/visitor-req.module`).then((m) => m.VisitorReqModule), canActivate: [OfflineGuard] },
  { path: '', redirectTo: 'features', pathMatch: 'full' },
  { path: "login", loadChildren: () => import(`./login/login.module`).then((m) => m.LoginModule) },
  { path: "error", loadChildren: () => import(`./errorpages/errorpages.module`).then((m) => m.ErrorpagesModule) },
  { path: "features", loadChildren: () => import(`./features/features.module`).then((m) => m.FeaturesModule), canActivate: [OfflineGuard] },
  { path: '#', redirectTo: '/login' },
  {path:'table',loadChildren: () => import(`./table/table.module`).then((m) => m.TableModule), canActivate: [OfflineGuard] },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true, onSameUrlNavigation: 'reload' }),],
  exports: [RouterModule],
})
export class AppRoutingModule { }
